export { default } from './components/expansion.panel';
